import { sendGet, sendPost, sendPut, sendDelete } from './generic';
import IResult from '../../models/result/IResult';
import CreateTagRequest from '../../models/configuration/CreateTagRequest';

export interface ExtraTagConfig {
    detectionPrompt: string;
    summarizationPromptAddition: string;
    autoTagFlags: string[];
    detectionTolerance: number;
}

export const getTagConfigData = (applicationId: string, fileName: string): Promise<IResult<string>> => {
    return sendGet<string>(`/TagConfig/${applicationId}/data?fileName=${encodeURIComponent(fileName)}`);
};

export const getTagConfig = (tagName: string, featureFlagId: string): Promise<IResult<ExtraTagConfig>> => {
    return sendGet<ExtraTagConfig>(`/TagConfig/tag-config?tagName=${encodeURIComponent(tagName)}&featureFlagId=${encodeURIComponent(featureFlagId)}`);
};

export const createTag = (request: CreateTagRequest): Promise<IResult<boolean>> => {
    return sendPost<boolean>(`/TagConfig/create`, request);
};

export const updateTag = (request: CreateTagRequest): Promise<IResult<boolean>> => {
    return sendPut<boolean>(`/TagConfig/update`, request);
};

export const removeTag = (tagName: string): Promise<IResult<boolean>> => {
    return sendDelete<boolean>(`/TagConfig/remove?tagName=${encodeURIComponent(tagName)}`);
};
